import React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
const { fonts } = themes;

const FutureFamilyCTA = () => {
  return (
    <Container>
      Kindbody is using Future Family for monthly financing. To get a better idea of treatment costs
      and ways to pay, explore your cycle costs here.&nbsp;
      <a href="https://payment-options.futurefamily.com/kindbody" target="_blank" rel="noreferrer">
        See payment options
      </a>
    </Container>
  );
};

export default FutureFamilyCTA;

const Container = styled.div`
  margin-top: 40px;
  ${fonts.DomaineDisplay};
  font-size: 22px;
  a {
    font-family: Helvetica;
    font-size: 18px;
    text-decoration: underline;
  }
`;
